import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { http } from "@/lib/api";
import { PageHeader, Section } from "@/components/Section";
import { TID } from "@/constants/testIds";

const Lyrics = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    http.get("/lyrics").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <>
      <PageHeader
        eyebrow="Divine Library"
        hindi="भजन एवं स्तोत्र"
        title="Lyrics & Meanings"
        subtitle="Every syllable in Sanskrit, translated into Hindi and English. Read as devotion. Read as literature. Read as fire."
      />
      <Section className="!py-16">
        <div className="grid gap-4">
          {items.map((l, i) => (
            <motion.div
              key={l.id}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
            >
              <Link
                to={`/lyrics/${l.id}`}
                data-testid={TID.lyricCard}
                className="group flex flex-col md:flex-row md:items-center gap-4 md:gap-8 glass rounded-2xl px-6 md:px-8 py-6 hover:border-[#FF9933]/40 hover:bg-[#111] transition-all"
              >
                <div className="md:w-1/3">
                  <div className="font-hindi text-2xl text-white">{l.hindi_title}</div>
                  <div className="mt-1 font-display text-xl text-white/90 tracking-tight">{l.title}</div>
                </div>
                <div className="md:flex-1 text-sm text-white/60 line-clamp-2 font-editorial text-lg">
                  “{l.english_translation.split(".")[0]}.”
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF9933] bg-[#FF9933]/10 border border-[#FF9933]/30 rounded-full px-3 py-1">
                    {l.deity}
                  </span>
                  {l.duration && (
                    <span className="hidden md:inline-flex items-center gap-1 text-[11px] text-white/50">
                      <Clock size={12} /> {l.duration}
                    </span>
                  )}
                  <ArrowRight size={16} className="text-white/40 group-hover:text-[#FF9933] group-hover:translate-x-1 transition-all" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </Section>
    </>
  );
};

export default Lyrics;
